import i18n from '@/i18n';

const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};

const DATE_TIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
};

const TIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
};

// yyyyMMdd (sem separadores) precisa de parsing manual: new Date() nativo trata
// esse formato como inválido/ambíguo em vários engines.
function parseDate(dateString: string): Date {
  if (/^\d{8}$/.test(dateString)) {
    const year = parseInt(dateString.substring(0, 4), 10);
    const month = parseInt(dateString.substring(4, 6), 10) - 1;
    const day = parseInt(dateString.substring(6, 8), 10);
    return new Date(year, month, day);
  }
  return new Date(dateString);
}

export const formatDate = (dateString: string): string => {
  if (!dateString) return i18n.t('common:dates.unavailable');

  const date = parseDate(dateString);
  if (isNaN(date.getTime())) return i18n.t('common:dates.invalid');

  return date.toLocaleDateString(i18n.language, DATE_FORMAT_OPTIONS);
};

export const formatDateTime = (dateString: string): string => {
  if (!dateString) return i18n.t('common:dates.unavailable');

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return i18n.t('common:dates.invalid');

  return date.toLocaleString(i18n.language, DATE_TIME_FORMAT_OPTIONS);
};

export const formatTime = (dateString: string): string => {
  if (!dateString) return i18n.t('common:dates.unavailable');

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return i18n.t('common:dates.invalid');

  return date.toLocaleTimeString(i18n.language, TIME_FORMAT_OPTIONS);
};

export const getRelativeTime = (dateString: string): string => {
  if (!dateString) return i18n.t('common:dates.unavailable');

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return i18n.t('common:dates.invalid');

  const diffInSeconds = Math.floor((Date.now() - date.getTime()) / 1000);

  // diff <= 0 nunca ocorre nos testes existentes (sempre usam deltas > 0);
  // cobre apenas o instante exato / clock skew, sem afetar a fidelidade pt-BR.
  if (diffInSeconds <= 0) return i18n.t('common:dates.justNow');

  if (diffInSeconds < 60) {
    return i18n.t('common:dates.secondsAgo', { count: diffInSeconds });
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return i18n.t('common:dates.minutesAgo', { count: diffInMinutes });
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return i18n.t('common:dates.hoursAgo', { count: diffInHours });
  }

  const diffInDays = Math.floor(diffInHours / 24);
  return i18n.t('common:dates.daysAgo', { count: diffInDays });
};
